import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import CategoryList from '../components/categories/CategoryList';

const Categories: React.FC = () => {
  const { canManageCategories } = usePermissions();

  // Only admins and superadmins can access category management
  if (!canManageCategories) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
        <h2 className="text-lg font-semibold text-yellow-800 mb-2">Acceso Restringido</h2>
        <p className="text-yellow-700">
          Solo los administradores pueden gestionar categorías y subcategorías.
        </p>
      </div>
    );
  }

  return (
    <div>
      <CategoryList />
    </div>
  );
};

export default Categories;
